import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=503b86fc&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=503b86fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503b86fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('503b86fc')) {
      api.createRecord('503b86fc', component.options)
    } else {
      api.reload('503b86fc', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=503b86fc&scoped=true&", function () {
      api.rerender('503b86fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23ho07D2vrbu6/JS/comp/CookieBox.vue"
export default component.exports